module.exports = __webpack_public_path__ + "img/pic_hands.bc7cbce9.svg";